


























import {defineComponent, PropType} from "@vue/composition-api";
import FormSection from "@tool/Components/FormSection.vue";
import FormError from "@tool/Components/FormError.vue";
import InputErrors from "@tool/Components/InputErrors.vue";
import useFormHelper from "@tool/Helpers/useFormHelper";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {ProjectEntityInterface} from "@tool/tool.types";
import useAxios from "@tool/Helpers/useAxios";
import {useToast} from "vue-toastification/composition";
import {useInertia} from "@tool/Helpers/useInertia";

export default defineComponent({
    components: {
        FormSection,
        FormError,
        InputErrors,
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        }
    },
    setup(props) {

        const form = useFormHelper({
            name: props.project.name,
            slug: props.project.slug,
        }, {
            slug: ''
        });

        const toast = useToast();

        const formValidator = useVuelidate({
            name: {
                required
            },
            slug: {
                required,
            }
        }, form.value.data);

        const formHandle = async () => {
            const response = await form.value.submit((data) => {
                return useAxios().put<ProjectEntityInterface>(
                        route('app.project.update', props.project.slug),
                        data
                );
            });


            if (response.success) {
                useInertia().get(route('app.project.settings.index', response.success.slug), {}, {
                    preserveScroll: true,
                    onSuccess() {
                        toast.success('Project was successfully updated!');
                    }
                });
            }
        }

        return {
            form,
            formValidator,
            formHandle,
        }
    }
});
